import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel-general-description" }
const _hoisted_2 = ["textContent"]

import HotelDescriptionGrid from '@lmt-rpb/HotelDescriptionGrid/HotelDescriptionGrid.vue';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import type { Description } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';

interface Props {
	hotelDescription: Description[];
	seeMoreButtonLabel?: string;
	title?: string;
	modalTitle?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelGeneralDescription',
  props: {
    hotelDescription: {},
    seeMoreButtonLabel: { default: 'Komplette Beschreibung' },
    title: { default: 'Allgemeine Beschreibung' },
    modalTitle: { default: 'Allgemeine Beschreibung' }
  },
  emits: ['show-more-button-click'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const showHotelInfosModal = () => {
	emit('show-more-button-click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", {
      class: "hotel-general-description__heading",
      textContent: _toDisplayString(_ctx.title)
    }, null, 8 /* PROPS */, _hoisted_2),
    _createVNode(HotelDescriptionGrid, {
      class: "hotel-general-description__items",
      descriptions: _ctx.hotelDescription,
      "column-direction": ""
    }, null, 8 /* PROPS */, ["descriptions"]),
    _createVNode(BaseModal, {
      class: "hotel-general-description__modal",
      "header-title": _ctx.modalTitle,
      "with-open-button": "",
      "open-button-props": { label: _ctx.seeMoreButtonLabel, class: 'hotel-general-description-modal-btn' },
      onOpen: showHotelInfosModal
    }, {
      default: _withCtx(() => [
        _createVNode(HotelDescriptionGrid, { descriptions: _ctx.hotelDescription }, null, 8 /* PROPS */, ["descriptions"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["header-title", "open-button-props"])
  ]))
}
}

})